const PIXEL_ID = '29103442459245161';

declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}

/**
 * Carga el Meta Pixel (equivalente al snippet oficial de Facebook) y
 * dispara el evento PageView. Es idempotente: si ya está inicializado
 * no vuelve a inyectar el script.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return;

  const fbq: any = function (...args: unknown[]) {
    fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
  };
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  // Fallback <noscript> del snippet oficial.
  const noscript = document.createElement('noscript');
  const pixelImg = document.createElement('img');
  pixelImg.height = 1;
  pixelImg.width = 1;
  pixelImg.style.display = 'none';
  pixelImg.alt = '';
  pixelImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
  noscript.appendChild(pixelImg);
  document.body.appendChild(noscript);

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}

/** Dispara un evento estándar del Meta Pixel (ej. InitiateCheckout). */
export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', event, params);
}
